<script lang="ts">
    import { _ } from "svelte-i18n"
    import { optionsConf } from "../../config"
    import { contentOverlay } from "../../store"
    import { isSelectableOption } from "../../utils"

    import ProductSummary from "./ProductSummary.svelte"

    export let callback: Function
    export let product: Product
    export let activeColor: RALColor = undefined
    export let activeOptions: string[] = []

    let activeOptionsMap: {
        [option: string]: boolean
    } = {}
    activeOptions.forEach((o) => {
        // pre select given choice
        activeOptionsMap[o] = true
    })

    let moreOptions: OptionEntry[]
    $: {
        moreOptions = product.options?.filter((o) => {
            if (o.option != "ral") {
                return true
            }
        })
    }

    // map to array (with validation)
    $: {
        const _activeOptions = []
        const _activeSelections = Object.keys(activeOptionsMap).filter((o) => {
            return !!activeOptionsMap[o]
        })
        moreOptions.forEach((o) => {
            if (activeOptionsMap[o.option] && isSelectableOption(o.option, _activeSelections, product)) {
                _activeOptions.push(o.option)
            }
        })
        activeOptions = _activeOptions
        callback(activeOptions)
    }
</script>

<div class="content">
    <ProductSummary product="{product}" color="{activeColor}" options="{activeOptions}" />

    <div class="header">
        <h3>{$_("options.headline")}</h3>
        <button
            class="btn btn-secondary"
            on:click="{() => {
                $contentOverlay = undefined
            }}">{$_("options.confirm-selection")}</button
        >
    </div>

    <div class="options">
        {#key activeOptions}
            {#each moreOptions as o}
                {#if isSelectableOption(o.option, activeOptions, product)}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <div
                        class="item"
                        class:active="{activeOptionsMap[o.option]}"
                        on:click="{() => {
                            activeOptionsMap[o.option] = !activeOptionsMap[o.option]
                        }}"
                    >
                        <div class="image">
                            <img src="{optionsConf[o.option]?.image}" alt="{o.option}" />
                        </div>
                        <div class="title">
                            {optionsConf[o.option]?.title}
                        </div>
                        <div class="description">
                            {optionsConf[o.option]?.text}
                        </div>
                        <div class="check"></div>
                    </div>
                {/if}
            {/each}
        {/key}
    </div>
</div>

<style lang="less">
    @import "../../css/variables.less";

    .content {
        padding: 20px 20px 60px 20px;
    }
    .header {
        .flex();
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
    }
    h3 {
        margin: 0px;
        margin-bottom: 0px;
    }

    .options {
        .flex();
        flex-wrap: wrap;
        .item {
            cursor: pointer;
            position: relative;
            padding: 30px 40px 30px 60px;
            margin-bottom: 20px;
            width: 100%;
            text-align: left;
            border: solid 3px transparent;
            @media (min-width: 1024px) {
                &:hover {
                    background: var(--background);
                }
            }
            &.active {
                border: solid 3px var(--primary);
            }
            .title {
                font-size: 1.2rem;
                font-weight: 700;
                margin-bottom: 10px;
            }
            .description {
                font-size: 0.8rem;
                line-height: 1.2;
                white-space: pre-line;
            }
        }
    }

    .check {
        position: absolute;
        top: 30px;
        left: 20px;
        transition: transform 0.28s ease;
        width: 25px;
        height: 25px;
        border-radius: 3px;
        border: solid 1px #c4102d;
        background: none;
        overflow: hidden;
        &:after {
            content: "";
            display: block;
            width: 11px;
            height: 4px;
            border-bottom: 2px solid #fff;
            border-left: 2px solid #fff;
            transform: rotate(-45deg) scale(0);
            transition: transform ease 0.25s;
            position: absolute;
            top: 6px;
            left: 5px;
        }
    }
    .active > .check {
        background: var(--primary);
        &:after {
            transform: rotate(-45deg) scale(1);
        }
    }
</style>
